export const FORM_NAME = 'accreditation-company-form';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
export const TABLE_TAX_ROWS_NAMES = {
	org_type: 'Тип организации',
	tax_system: 'Система налогообложения',
	tax_rate: 'Налоговая ставка',
};
export const FIELDS_FOR_VALIDATE = ['org_type_id', 'tax_system_id', 'tax_rate_id'];
